<div class="rc-backdrop" [class.rc-backdrop--dim]="!isAnchored" [class.rc-closing]="isClosing" (click)="answer(false)"></div>
<div
  #card
  class="rc-pop"
  [class.rc-pop--center]="!isAnchored"
  [class.rc-closing]="isClosing"
  role="alertdialog"
  aria-modal="true"
  [attr.aria-label]="options.title">
  <span #arrow class="rc-arrow" [hidden]="!isAnchored"></span>

  <div class="rc-body">
    <span class="rc-icon"><i [class]="icon"></i></span>
    <div class="rc-text">
      <div class="rc-title">{{ options.title }}</div>
      <div class="rc-message" *ngIf="options.message">{{ options.message }}</div>
      <span class="rc-subject" *ngIf="options.subject" [title]="options.subject">{{ options.subject }}</span>
    </div>
  </div>

  <div class="rc-actions">
    <button *ngIf="!options.hideCancel" type="button" class="_cancel-btn rc-btn" (click)="answer(false)">
      {{ options.cancelLabel }}
    </button>
    <button #confirmBtn type="button" class="_primary-btn rc-btn" (click)="answer(true)">
      {{ options.confirmLabel }}
    </button>
  </div>
</div>
